import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const FavCtx = createContext(null);

export function FavoritesProvider({ children }) {
  const { user } = useAuth();
  const [favSet, setFavSet] = useState(new Set());

  const load = useCallback(async () => {
    if (!user) { setFavSet(new Set()); return; }
    try {
      const { data } = await api.get("/favorites");
      setFavSet(new Set(data));
    } catch (e) { /* ignore */ }
  }, [user]);

  useEffect(() => { load(); }, [load]);

  const toggle = async (assetId) => {
    const next = new Set(favSet);
    if (next.has(assetId)) {
      next.delete(assetId);
      setFavSet(next);
      try { await api.delete(`/favorites/${assetId}`); } catch { load(); }
    } else {
      next.add(assetId);
      setFavSet(next);
      try { await api.post(`/favorites/${assetId}`); } catch { load(); }
    }
  };

  return (
    <FavCtx.Provider value={{ favSet, toggle, reload: load }}>
      {children}
    </FavCtx.Provider>
  );
}

export const useFavorites = () => useContext(FavCtx);
